import React, { useEffect, useState } from "react";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { isEqual } from "underscore";
import TocStockHeader from "../TocHeader/TocStockHeader";
import SingleHeadingText from "../TocHeader/SingleHeadingText";
import OrderConfirmation from "@frameworks/web/components/generic/TOCgeneric/OrderConfirmation";
import BuySellBtn from "../Stock/BuySellBtn";
import MarginShortFunds from "../Stock/MarginShortFunds";
import OrderMsg from "@frameworks/web/components/generic/OrderMsg/OrderMsg";
import StockQuote from "../TocHeader/StockQuote";
import di from "@frameworks/web/components/features/TOC/di/servicelocator";
import { TOCBUYORSELL } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import { eqProducts } from "../../Equity/EqConstants";
import ChartiqBtmDrawer from "@frameworks/web/components/generic/ChartiqBtmDrawer";
import { useNavigate, useLocation } from "react-router-dom";
import config from "@frameworks/web/config/domain";
import { ITOCScreenStateEnum, checkTocState, getProductValues, } from "../../constant";
import { useSelector } from "react-redux";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import * as moment from "moment";
import { addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
const OrderConfirmationMain = (props) => {
    const device = DeviceContext();
    const navigate = useNavigate();
    const location = useLocation();
    const [screenState, setScreenState] = useState(ITOCScreenStateEnum.ORDER_CONFIRM);
    const [isSuccessRes, setIsSuccessRes] = useState(false);
    const [sipsuccess, setSipsuccess] = React.useState(false);
    const { multiQuote: multiQuote } = useSelector((state) => state.TOCJourney.multiQuoteReducers, isEqual);
    const { data: checkMarginData } = useSelector((state) => state.TOCJourney.checkMargin, isEqual);
    const { userID, empOrDependent } = useSelector((state) => state.accountDetailsReducer, isEqual);
    useEffect(() => {
        return () => {
            // Anything in here is fired on component unmount.
            di.tocJourney.flushPlaceOrderError();
            di.tocJourney.flushPlaceOrderData();
        };
    }, []);
    const { data: placeNormalTrade, loader: placeNormalTradeLoader, errorData: placeNormalTradeError, } = useSelector((state) => state.TOCJourney.placeNormalTrade, isEqual);
    const { data: orderDetails, loader: orderDetailsLoader, errorData: orderDetailsError, } = useSelector((state) => state.TOCJourney.orderDetails, isEqual);
    const onCompUnmount = async () => {
        setScreenState(ITOCScreenStateEnum.ORDER_CONFIRM);
        props.setConfirmOrder(false);
    };
    const placeOrder = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
        let payloadNormal = {
            userID: userID,
            body: {
                trdSym: (_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                sym: (_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.symbol,
                dur: (_c = props === null || props === void 0 ? void 0 : props.activeButton) === null || _c === void 0 ? void 0 : _c.VALIDITY,
                ordTyp: ((_d = props === null || props === void 0 ? void 0 : props.activeButton) === null || _d === void 0 ? void 0 : _d.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_e = props === null || props === void 0 ? void 0 : props.activeButton) === null || _e === void 0 ? void 0 : _e.ORDER,
                qty: (_f = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _f === void 0 ? void 0 : _f.quantity,
                dscQty: (_g = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _g === void 0 ? void 0 : _g.disclosedQuantity,
                lmPrc: (_h = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _h === void 0 ? void 0 : _h.limitPrice,
                trgPrc: (_j = props.tradeValues) === null || _j === void 0 ? void 0 : _j.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_k = props === null || props === void 0 ? void 0 : props.activeButton) === null || _k === void 0 ? void 0 : _k.PRODUCT) ||
                    ((_l = props === null || props === void 0 ? void 0 : props.activeButton) === null || _l === void 0 ? void 0 : _l.PRODUCT),
                ordSrc: "TOC",
            },
        };
        let payloadCO = {
            userID: userID,
            body: {
                sym: (_m = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _m === void 0 ? void 0 : _m.symbol,
                dur: (_o = props === null || props === void 0 ? void 0 : props.activeButton) === null || _o === void 0 ? void 0 : _o.VALIDITY.toUpperCase(),
                lmPrc: (_p = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _p === void 0 ? void 0 : _p.limitPrice,
                ordTyp: ((_q = props === null || props === void 0 ? void 0 : props.activeButton) === null || _q === void 0 ? void 0 : _q.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_r = props === null || props === void 0 ? void 0 : props.activeButton) === null || _r === void 0 ? void 0 : _r.ORDER,
                action: props.action.toUpperCase(),
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_s = props === null || props === void 0 ? void 0 : props.activeButton) === null || _s === void 0 ? void 0 : _s.PRODUCT) ||
                    ((_t = props === null || props === void 0 ? void 0 : props.activeButton) === null || _t === void 0 ? void 0 : _t.PRODUCT),
                exc: props.exchange,
                qty: (_u = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _u === void 0 ? void 0 : _u.quantity,
                trdSym: (_v = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _v === void 0 ? void 0 : _v.tradeSymbol,
                dscQty: (_w = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _w === void 0 ? void 0 : _w.disclosedQuantity,
                trgPrc: (_x = props.tradeValues) === null || _x === void 0 ? void 0 : _x.triggerPrice,
                ordSrc: "TOC",
                locInd: "WEB",
                vlDt: "",
                empOrDependent: empOrDependent,
            },
        };
        let payloadAMO = {
            amoBody: {
                trdSym: (_y = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _y === void 0 ? void 0 : _y.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                dur: (_z = props === null || props === void 0 ? void 0 : props.activeButton) === null || _z === void 0 ? void 0 : _z.VALIDITY.toUpperCase(),
                qty: (_0 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _0 === void 0 ? void 0 : _0.quantity,
                dscQty: (_1 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _1 === void 0 ? void 0 : _1.disclosedQuantity,
                lmPrc: (_2 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _2 === void 0 ? void 0 : _2.limitPrice,
                trgPrc: (_3 = props.tradeValues) === null || _3 === void 0 ? void 0 : _3.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_4 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _4 === void 0 ? void 0 : _4.PRODUCT) ||
                    ((_5 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _5 === void 0 ? void 0 : _5.PRODUCT),
                ordSrc: "TOC",
                ordTyp: ((_6 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _6 === void 0 ? void 0 : _6.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_7 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _7 === void 0 ? void 0 : _7.ORDER,
                sym: (_8 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _8 === void 0 ? void 0 : _8.symbol,
            },
            userID: userID,
        };
        let payloadEsip = {
            EsipBody: {
                trdSym: (_9 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _9 === void 0 ? void 0 : _9.tradeSymbol,
                exc: props.exchange,
                trTyp: TOCBUYORSELL.SIP,
                inv: (props === null || props === void 0 ? void 0 : props.showAmount) ? "Amount" : "Quantity",
                val: (props === null || props === void 0 ? void 0 : props.showAmount)
                    ? (_10 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _10 === void 0 ? void 0 : _10.amount
                    : (_11 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _11 === void 0 ? void 0 : _11.quantity,
                freq: (_12 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _12 === void 0 ? void 0 : _12.FREQUENCY,
                brid: "BOMBAY",
                brk: "EBL_CAS",
                tnr: +((_13 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _13 === void 0 ? void 0 : _13.totalperiod),
                stDt: moment(props === null || props === void 0 ? void 0 : props.tradeValues.startDate).format("DD-MM-YYYY"),
                prCd: (_14 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _14 === void 0 ? void 0 : _14.PRODUCT,
            },
            userID: userID,
        };
        let payloadBO = {
            userID: userID,
            bracketTradeBody: {
                exc: props === null || props === void 0 ? void 0 : props.exchange,
                sym: (_15 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _15 === void 0 ? void 0 : _15.symbol,
                trnsTyp: (_16 = props === null || props === void 0 ? void 0 : props.action) === null || _16 === void 0 ? void 0 : _16.toUpperCase(),
                qty: (_17 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _17 === void 0 ? void 0 : _17.quantity,
                dur: (_18 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _18 === void 0 ? void 0 : _18.VALIDITY,
                prc: (_19 = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _19 === void 0 ? void 0 : _19.lastTradedPrice,
                sqOffVal: (_20 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _20 === void 0 ? void 0 : _20.target,
                slVal: (_21 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _21 === void 0 ? void 0 : _21.stopLoss,
                trlSl: "N",
                trlSlVal: null,
                ordSrc: "TOC",
                trdBsdOn: "LTP",
                sqOffBsdOn: "Absolute",
                slBsdOn: "Absolute",
            },
        };
        if ((_22 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _22 === void 0 ? void 0 : _22.disclosedQuantity)
            payloadBO = Object.assign(Object.assign({}, payloadBO), { bracketTradeBody: Object.assign(Object.assign({}, payloadBO.bracketTradeBody), { dsQty: (_23 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _23 === void 0 ? void 0 : _23.disclosedQuantity }) });
        if (props.exchange === "OFS") {
            let payloadOFS = {
                userID: userID,
                body: {
                    issueId: (_24 = props.tradeValues) === null || _24 === void 0 ? void 0 : _24.issueId,
                    cutOff: ((_25 = props.tradeValues) === null || _25 === void 0 ? void 0 : _25.orderType) == "Retails" ? "Y" : "N",
                    orderType: ((_26 = props.tradeValues) === null || _26 === void 0 ? void 0 : _26.orderType) == "Retails"
                        ? props.tradeValues.orderType
                        : "Non-Institutional",
                    exch: "NSE",
                    price: (_27 = props.tradeValues) === null || _27 === void 0 ? void 0 : _27.amount,
                    buyQty: (_28 = props.tradeValues) === null || _28 === void 0 ? void 0 : _28.quantity,
                },
            };
            di.tocJourney.placeOfsTrade(payloadOFS);
        }
        else if (props.action === TOCBUYORSELL.SIP) {
            di.tocJourney.placeEsipTrade(payloadEsip);
            setSipsuccess(true);
        }
        else if (props.amoOrder &&
            (props.exchange == "MCX" || props.exchange == "NCDEX")) {
            payloadAMO.amoBody.prdCode =
                getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_29 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _29 === void 0 ? void 0 : _29.PRODUCT) ||
                    ((_30 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _30 === void 0 ? void 0 : _30.PRODUCT);
            payloadAMO.amoBody.qty = (_31 = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _31 === void 0 ? void 0 : _31.quantity;
            payloadAMO.amoBody.ordSrc = "TOC";
            payloadAMO.amoBody.locInd = "WEB";
            payloadAMO.amoBody.vlDt = "";
            payloadAMO.amoBody.empOrDependent = empOrDependent;
            di.tocJourney.placeAMOTradeComm(payloadAMO);
        }
        else if (props.amoOrder &&
            !(props.exchange == "MCX" || props.exchange == "NCDEX")) {
            di.tocJourney.placeAMOTrade(payloadAMO);
        }
        else if (props.exchange == "MCX" || props.exchange == "NCDEX")
            di.tocJourney.placeTradeComm(payloadCO);
        else if (((_32 = props === null || props === void 0 ? void 0 : props.activeButton) === null || _32 === void 0 ? void 0 : _32.PRODUCT) ===
            eqProducts.find((x) => x.title === "BO").title)
            di.tocJourney.placeBracketTrade(payloadBO);
        else
            di.tocJourney.placeNormalTrade(payloadNormal);
    };
    const modifyOrder = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        let payloadNormal = {
            userID: userID,
            isAmo: props.amoOrder,
            body: {
                trdSym: (_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.tradeSymbol,
                exc: props.exchange,
                action: props.action.toUpperCase(),
                sym: (_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.symbol,
                dur: (_c = props === null || props === void 0 ? void 0 : props.activeButton) === null || _c === void 0 ? void 0 : _c.VALIDITY,
                ordTyp: ((_d = props === null || props === void 0 ? void 0 : props.activeButton) === null || _d === void 0 ? void 0 : _d.ORDER) === "SL"
                    ? "STOP_LIMIT"
                    : (_e = props === null || props === void 0 ? void 0 : props.activeButton) === null || _e === void 0 ? void 0 : _e.ORDER,
                qty: (_f = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _f === void 0 ? void 0 : _f.quantity,
                dscQty: (_g = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _g === void 0 ? void 0 : _g.disclosedQuantity,
                lmPrc: (_h = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _h === void 0 ? void 0 : _h.limitPrice,
                trgPrc: (_j = props.tradeValues) === null || _j === void 0 ? void 0 : _j.triggerPrice,
                prdCode: getProductValues(props === null || props === void 0 ? void 0 : props.buttonList, (_k = props === null || props === void 0 ? void 0 : props.activeButton) === null || _k === void 0 ? void 0 : _k.PRODUCT) ||
                    ((_l = props === null || props === void 0 ? void 0 : props.activeButton) === null || _l === void 0 ? void 0 : _l.PRODUCT),
                ordSrc: "TOC",
                nstOID: (_m = props === null || props === void 0 ? void 0 : props.modifyData) === null || _m === void 0 ? void 0 : _m.orderId,
                flQty: (_o = props === null || props === void 0 ? void 0 : props.modifyData) === null || _o === void 0 ? void 0 : _o.flQty,
            },
        };
        di.tocJourney
            .modifyOrder(payloadNormal)
            .then((data) => {
            (device === null || device === void 0 ? void 0 : device.isDesktop)
                ? props === null || props === void 0 ? void 0 : props.afterModifyAction(data === null || data === void 0 ? void 0 : data.msg)
                : navigate(props === null || props === void 0 ? void 0 : props.afterMarketRedirect, { state: { msg: data === null || data === void 0 ? void 0 : data.msg } });
        })
            .catch((error) => {
            (device === null || device === void 0 ? void 0 : device.isDesktop)
                ? props === null || props === void 0 ? void 0 : props.afterModifyAction(error.getErrorMessageOrErrMsg())
                : navigate(props === null || props === void 0 ? void 0 : props.afterMarketRedirect, {
                    state: { msg: error.getErrorMessageOrErrMsg() },
                });
        });
    };
    const SIPOROther = () => {
        if (!placeNormalTradeLoader &&
            !placeNormalTradeError.isOpen &&
            placeNormalTrade.success) {
            if (props.action === TOCBUYORSELL.SIP && sipsuccess) {
                setScreenState(ITOCScreenStateEnum.SUCCESS_ORDER);
            }
            else {
                let payload = {
                    userID: userID,
                    orderID: placeNormalTrade.orderID,
                    isComm: props.exchange == "MCX" || props.exchange == "NCDEX",
                };
                di.tocJourney.orderDetails(payload);
            }
        }
        else if (!placeNormalTradeLoader && placeNormalTradeError.isOpen) {
            setScreenState(ITOCScreenStateEnum.REJECTED_ORDER);
        }
    };
    useEffect(() => {
        var _a, _b;
        if (!placeNormalTradeError.isOpen) {
            if (!orderDetailsLoader &&
                !orderDetailsError.isOpen &&
                ((_a = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetails) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                (checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.insufficientFund)) {
                setScreenState(ITOCScreenStateEnum.INSUFFICIENT_FUND);
            }
            else if (!orderDetailsLoader &&
                !orderDetailsError.isOpen &&
                ((_b = orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.orderDetails) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                if ((props === null || props === void 0 ? void 0 : props.tocState) === OrderbookTocStateEnum.REORDER) {
                    (device === null || device === void 0 ? void 0 : device.isDesktop)
                        ? props === null || props === void 0 ? void 0 : props.afterModifyAction(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.message)
                        : navigate(props === null || props === void 0 ? void 0 : props.afterMarketRedirect, {
                            state: { msg: placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.message },
                        });
                }
                else {
                    setScreenState(ITOCScreenStateEnum.SUCCESS_ORDER);
                }
            }
            else if (!orderDetailsLoader && (orderDetailsError === null || orderDetailsError === void 0 ? void 0 : orderDetailsError.isOpen)) {
                setScreenState(ITOCScreenStateEnum.REJECTED_ORDER);
            }
        }
    }, [orderDetailsLoader, orderDetailsError, orderDetails.orderDetails]);
    useEffect(() => {
        SIPOROther();
    }, [placeNormalTradeLoader, placeNormalTradeError, placeNormalTrade]);
    const screenHeader = () => {
        return (React.createElement(React.Fragment, null, device.isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(TocStockHeader, { children: isSuccessRes ? (React.createElement(StockQuote, { stockQuoteDetails: multiQuote, setChartIQ: () => {
                        setScreenState(ITOCScreenStateEnum.CHART_IQ);
                    } })) : (React.createElement(SingleHeadingText, { title: "Order Confirmation" })) }))) : ("")));
    };
    const screenHandler = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        switch (screenState) {
            case ITOCScreenStateEnum.CHART_IQ:
                return (React.createElement(ChartiqBtmDrawer, { symbol: ((_a = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.symbol) || "", instru: ((_b = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.asTyp) || "", disable: true, showCross: true, goBack: () => setScreenState(ITOCScreenStateEnum.ORDER_CONFIRM) }));
            case ITOCScreenStateEnum.ORDER_CONFIRM:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement(OrderConfirmation, { headingWithBackBtn: props.headingWithBackBtn ? props.headingWithBackBtn : false, viewAllbackLink: props.viewAllbackLink ? props.viewAllbackLink : "", stockName: (_c = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.dpName, description: (_d = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _d === void 0 ? void 0 : _d.description, change: (_e = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _e === void 0 ? void 0 : _e.change, changePer: (_f = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _f === void 0 ? void 0 : _f.changePercentage, ltp: (_g = multiQuote === null || multiQuote === void 0 ? void 0 : multiQuote.quotesDetailsEntity[0]) === null || _g === void 0 ? void 0 : _g.lastTradedPrice, orderBodyList: checkMarginData &&
                            (checkMarginData.orderMargin || checkMarginData.availableCash)
                            ? [
                                ...props === null || props === void 0 ? void 0 : props.orderConfirmationList,
                                {
                                    title: "Margin required",
                                    value: addCommasWithoutDecimal(checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.orderMargin),
                                },
                                {
                                    title: "Available",
                                    value: addCommasWithoutDecimal(checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.availableCash),
                                },
                            ]
                            : [
                                ...props === null || props === void 0 ? void 0 : props.orderConfirmationList,
                                {
                                    title: "Margin required",
                                    value: ((_h = props.marginData) === null || _h === void 0 ? void 0 : _h.fundRequired)
                                        ? (_j = props.marginData) === null || _j === void 0 ? void 0 : _j.fundRequired
                                        : "-",
                                },
                                {
                                    title: "Available",
                                    value: ((_k = props.marginData) === null || _k === void 0 ? void 0 : _k.marginAvail)
                                        ? (_l = props.marginData) === null || _l === void 0 ? void 0 : _l.marginAvail
                                        : "-",
                                },
                            ], exchange: props === null || props === void 0 ? void 0 : props.exchange, quantity: (_m = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _m === void 0 ? void 0 : _m.quantity, validity: (_o = props === null || props === void 0 ? void 0 : props.activeButton) === null || _o === void 0 ? void 0 : _o.VALIDITY, activeButton: props === null || props === void 0 ? void 0 : props.activeButton, disclosedQty: props.action === TOCBUYORSELL.SIP
                            ? (_p = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _p === void 0 ? void 0 : _p.quantity
                            : (_q = props === null || props === void 0 ? void 0 : props.tradeValues) === null || _q === void 0 ? void 0 : _q.disclosedQuantity, hideAdditionalDetails: props.hideAdditionalDetails, showPaymentNotification: props.showPaymentNotification, showMandate: props.showMandate, declarationMsg: props === null || props === void 0 ? void 0 : props.declarationMsg }),
                    React.createElement("div", { className: "bottom-contents" }, props.isConfirmationBtn ? (React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                            btnTyp: "midnight-blue",
                            value: `Confirm`,
                            className: "w-100",
                            onClick: () => props.setpaymentMethod(true),
                        }, cancelAction: () => props.setConfirmOrder(false) })) : (React.createElement(React.Fragment, null,
                        React.createElement(MarginShortFunds, { title: "" }),
                        React.createElement(BuySellBtn, { refreshLabelTitle: "Sell", rightButton: {
                                btnTyp: `${props.action === TOCBUYORSELL.BUY ||
                                    props.action === TOCBUYORSELL.SIP
                                    ? "green-btn"
                                    : "red-btn"}`,
                                value: `Confirm ${checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                                    ? "Modify"
                                    : props.action === TOCBUYORSELL.BUY ||
                                        props.action === TOCBUYORSELL.SIP
                                        ? "Buy"
                                        : "Sell"}`,
                                className: "w-100",
                                onClick: () => {
                                    if (checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)) {
                                        modifyOrder();
                                    }
                                    else {
                                        placeOrder();
                                    }
                                },
                            }, cancelAction: () => {
                                onCompUnmount();
                            } }))))));
            case ITOCScreenStateEnum.INSUFFICIENT_FUND:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement(OrderMsg, { title: "Order Rejected", status: false, state: screenState, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, sortFunds: checkMarginData === null || checkMarginData === void 0 ? void 0 : checkMarginData.insufficientFund, btnvalueleft: {
                            value: "Add Funds",
                            btnTyp: "midnight-blue-border",
                            className: "w-100 pe-2 me-2",
                            onClick: () => {
                                navigate(config.feReportBase + "/fund-transfer");
                            },
                        }, btnvalueright: {
                            value: "Modify Order",
                            btnTyp: "midnight-blue",
                            className: "w-100 ms-2",
                            onClick: () => {
                                onCompUnmount();
                            },
                        }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" })));
            case ITOCScreenStateEnum.SUCCESS_ORDER:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white common-drawer-scroll  " },
                        React.createElement(OrderMsg, { title: "Order Received", state: screenState, status: true, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, btnvalueleft: {
                                value: "Go to Positions",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 pe-2 me-2",
                                onClick: () => {
                                    navigate(config.feReportBase + "/?reportName=Position");
                                },
                            }, btnvalueright: {
                                value: "Go to Orderbook",
                                btnTyp: "midnight-blue",
                                className: "w-100 ms-2",
                                onClick: () => {
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        navigate("/orderbook/eq/esip");
                                    }
                                    else
                                        navigate("/orderbook/eq");
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
            case ITOCScreenStateEnum.REJECTED_ORDER:
                return (React.createElement(React.Fragment, null,
                    screenHeader(),
                    React.createElement("div", { className: "bg_white common-drawer-scroll " },
                        React.createElement(OrderMsg, { title: "Order Rejected", state: screenState, status: false, tradeValue: props === null || props === void 0 ? void 0 : props.action, multiQuote: multiQuote, btnvalueleft: {
                                value: "Go to Orderbook",
                                btnTyp: "midnight-blue-border",
                                className: "w-100 ms-2",
                                onClick: () => {
                                    if (props.action === TOCBUYORSELL.SIP) {
                                        navigate("/orderbook/eq/esip");
                                    }
                                    else
                                        navigate("/orderbook/eq");
                                },
                            }, hideRightBtn: props.exchange === "OFS" ? true : false, btnvalueright: {
                                value: "Modify Order",
                                btnTyp: "midnight-blue",
                                className: "w-100 ms-2",
                                onClick: () => {
                                    onCompUnmount();
                                },
                            }, parentbuttonClass: "btn-class-btntype bottom-contents pb-2" }))));
        }
    };
    return (React.createElement(React.Fragment, null, orderDetailsLoader ? React.createElement(Common_Shimmer, null) : screenHandler()));
};
export default OrderConfirmationMain;
